import { useFlags } from "launchdarkly-react-client-sdk";

import { useAppSelector } from "app/hooks";
import { SCHEDULING_ENFORCE_DEDICATED_SLOTS } from "constants/feature-flags";
import { selectCurrentPractice } from "features/auth/auth-slice";
import useUserRoles from "hooks/use-user-roles.hook";

/**
 * ENG-2105. `isEnforced`: the flag and the practice setting are both on. `mustRespect`: enforced
 * AND this user can't override, i.e. the form should block rather than offer the checkbox.
 * `isFlagOn`: the flag alone. ENG-2154: it decides how the legacy form presents a collision (one
 * warning box, checkbox inside), whether or not the practice enforces.
 */
export const useDedicatedSlotEnforcement = () => {
  const flags = useFlags();
  const currentPractice = useAppSelector(selectCurrentPractice);
  const { canOverrideDedicatedSlots } = useUserRoles();

  const isFlagOn = Boolean(flags[SCHEDULING_ENFORCE_DEDICATED_SLOTS]);
  const isEnforced = Boolean(
    isFlagOn && currentPractice?.scheduling_enforce_dedicated_slots
  );

  return {
    isFlagOn,
    isEnforced,
    canOverride: canOverrideDedicatedSlots,
    mustRespect: isEnforced && !canOverrideDedicatedSlots
  };
};
